import { useEffect, useState } from "react";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import { ContactForm } from "./components/ContactForm";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import { Features } from "./components/features";
import { Footer } from "./components/footer";
import { Header } from "./components/header";
import { Navigation } from "./components/navigation";
import { Testimonials } from "./components/testimonials";

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    window.location.href =
      "https://apps.apple.com/us/app/%E3%81%93%E3%81%84%E3%81%A9%E3%81%86%E3%81%97%E3%82%83/id6695738279";
  }, []);

  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Header data={landingPageData.Header} />
                <Features data={landingPageData.Features} />
                <Testimonials data={landingPageData.Testimonials} />
                <Footer />
              </>
            }
          />
          <Route path="/signup" element={<ContactForm />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
